<template lang="pug">
.portal--base-wrapper
  keep-alive
    router-view(:key="$route.fullPath")
</template>

<script>
export default {
  name: "PortalLayout"
}
</script>

<style lang="scss" scoped>
.portal--base-wrapper{
  //width: $content_width;
  background-color: #E5E5E5;
}
</style>
